/**
 * Show the runs used by a specific job version to allow user to select one.
 *
 * TODO: Do we want to truncate the run name if long?
 */

// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
import {formatTimestamp} from '@wandb/weave/components/Timestamp';
import React, {useState} from 'react';

import {JobRun, JobRuns} from '../JobDetail/utilTypes';
import {ColorIndicator} from '../LinkRun';
import * as S from './SelectRunPanel.styles';

type SelectRunPanelProps = {
  runs: JobRuns;
  customRunColors: Record<string, string>;
  locked?: boolean;
  onSelectRun: (run: JobRun) => void;
  onClose: () => void;
};

const runMatches = (run: JobRun, searchText: string): boolean => {
  const searchLower = searchText.toLowerCase();
  if (run.displayName.toLowerCase().includes(searchLower)) {
    return true;
  }
  const creator = run.creator?.username ?? 'Unknown';
  if (creator.toLowerCase().includes(searchLower)) {
    return true;
  }
  return false;
};

export const SelectRunPanel = ({
  runs,
  customRunColors,
  locked,
  onSelectRun,
  onClose,
}: SelectRunPanelProps) => {
  const [searchText, setSearchText] = useState('');
  const onSearchChange = (value: string) => {
    setSearchText(value);
  };
  const filteredRuns = searchText
    ? runs.filter(run => runMatches(run, searchText))
    : runs;

  const onClickRun = (run: JobRun) => {
    onSelectRun(run);
    onClose();
  };

  return (
    <S.Panel>
      <TextField
        placeholder="Search run name or creator"
        value={searchText}
        onChange={onSearchChange}
        disabled={locked}
      />
      <S.Spacer />
      <S.Runs>
        {filteredRuns.map(run => (
          <S.Run key={run.id} onClick={() => onClickRun(run)}>
            <S.RunNameRow>
              <S.ColorIndicator>
                <ColorIndicator
                  name={run.name}
                  defaultColor={run.defaultColor}
                  customRunColors={customRunColors}
                />
              </S.ColorIndicator>
              <div>
                <div>{run.displayName}</div>
                <S.SecondRow>
                  {formatTimestamp(run.createdAt).short}・
                  {run.creator?.username ?? 'Unknown'}
                </S.SecondRow>
              </div>
            </S.RunNameRow>
          </S.Run>
        ))}
      </S.Runs>
      {!filteredRuns.length && <S.NoMatches>No matches</S.NoMatches>}
    </S.Panel>
  );
};
